import { round } from 'lodash';

/**
 * Nunjucks is passing the options arguments into args as a dictionary (for whatever reason)
 *
 * @param  {Int} number     Number to round
 * @param  {Int} step       Step to round (2 -> every half, 4 -> every .25)
 * @param  {Int} precision  Decimal places to return
 *
 * @return {Float}          Formatted number
 */
export function roundStep(number, step = 2, precision = 1) {
    return (round(number * step) / step).toFixed(precision).toString();
}
